import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";

const DiscussionItem = ({ item, index, children }) => {
  return (
    <Stack
      direction={"row"}
      sx={{
        borderBottom: "1px solid rgba(0,0,0,0.1)",
        pb: 1,
        // mb: 2,
        pt: 2,
      }}
      spacing={2}
      key={index}
    >
      <img
        src={item?.image}
        alt="discussion"
        style={{
          height: "35px",
          width: "35px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
        }}
      >
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Typography
            sx={{
              color: colors.primary,
              fontSize: "14px",
              fontFamily: "Mulish-Bold",
              maxWidth: "80%",
            }}
          >
            {item?.title || item?.name}
          </Typography>
          <Typography
            sx={{
              color: "rgba(25,34,52,0.5)",
              fontSize: "12px",
              fontFamily: "Mulish-Medium",
            }}
          >
            {item?.time}
          </Typography>
        </Stack>
        <Typography
          sx={{
            color: "rgba(25,34,52,0.5)",
            fontSize: "12px",
            fontFamily: "Mulish-Medium",
            mt: 0.5,
          }}
        >
          {item?.msg}
        </Typography>

        {children && children}
      </Box>
    </Stack>
  );
};

export default DiscussionItem;
